module.exports = __webpack_public_path__ + "img/plan_photo.8b10d4ff.jpg";